import { ChevronDown, CrossIcon } from "../../assets/icons";

/** Même hauteur que Button size SMI (h-9 = 36px), border incluse (border-box) */
const TRIGGER_BASE =
  "w-full h-9 box-border border rounded-md transition-colors border-gray-100 text-left ft-sm flex items-center";
/** État vide — aligné sur Button SECONDARY (hover / active) */
const TRIGGER_UNSELECTED =
  "bg-white text-gray-900 hover:bg-gray-100 active:bg-gray-200";
/** État avec sélection — fond marque (violet) */
const TRIGGER_SELECTED =
  "bg-workfully-600 text-white hover:bg-workfully-700 active:bg-workfully-800";

/**
 * Déclencheur des listes selectMultipleCheckbox / selectMultipleRadio (StyledInput).
 * Un seul composant pour le survol / press cohérents sur toute l’app.
 * @param {(ctx: { hasSelection: boolean }) => React.ReactNode} [renderValue] — remplace le libellé texte (plusieurs lignes possibles).
 */
const SelectMultipleTrigger = ({
  hasSelection,
  value,
  renderValue,
  onToggleOpen,
  variant = "checkbox",
  onClearAll,
}) => {
  const hasRichTrigger = typeof renderValue === "function";
  const useSelectedHighlight = hasSelection && variant === "checkbox";
  const surface = `${TRIGGER_BASE} ${hasRichTrigger ? "min-h-9 h-auto py-1" : "h-9"} ${useSelectedHighlight ? TRIGGER_SELECTED : TRIGGER_UNSELECTED} px-1.5`;

  const display =
    hasRichTrigger && renderValue ? renderValue({ hasSelection }) : value;

  return (
    <div onClick={onToggleOpen} className={surface}>
      <div className="flex min-h-0 w-full min-w-0 flex-1 items-center justify-between gap-1">
        <div
          className={`min-w-0 flex-1 pr-1 ${hasRichTrigger ? "flex flex-col gap-0.5 justify-center" : "truncate leading-5"}`}
        >
          {display}
        </div>
        {(!hasSelection || variant === "radio") && (
          <div className="flex shrink-0 items-center pl-1">
            <ChevronDown wh={20} color="#374151" />
          </div>
        )}
        {hasSelection && variant === "checkbox" && (
          <div
            className="flex shrink-0 items-center pl-0.5"
            onClick={(e) => {
              e.stopPropagation();
              onClearAll?.();
            }}
          >
            <CrossIcon wh={16} color="#FFFFFF" />
          </div>
        )}
      </div>
    </div>
  );
};

export default SelectMultipleTrigger;
